import { ScheduleAPI } from '../../../api/datamanager/ScheduleAPI';

export class SchedulesCommand {
    get(edition, providerId, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.list(edition.planning, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os horários");
            }
        });
    }

    count(edition, providerId, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.countActive(edition.planning, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, schedule, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(undefined === schedule.id || 0 === schedule.id) {
            apiResult = ScheduleAPI.create(edition.planning, schedule);
            successMessage = "Horário criado com sucesso";
        }
        else {
            apiResult = ScheduleAPI.update(schedule.planningEdition, schedule.id, schedule);
            successMessage = "Horário editado com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(planningEdition, scheduleId, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.delete(planningEdition, scheduleId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Horário eliminado com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/SchedulesCommand.js